<template>
    <div class="reading-progress-container" aria-hidden="true">
        <div class="reading-progress-bar" :style="{ width: `${progress}%` }"></div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const progress = ref(0)
let ticking = false

const updateProgress = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight

    progress.value = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0
    ticking = false
}

const handleScroll = () => {
    if (!ticking) {
        requestAnimationFrame(updateProgress)
        ticking = true
    }
}

onMounted(() => {
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', updateProgress)
    updateProgress();
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    window.removeEventListener('resize', updateProgress)
})
</script>

<style scoped>
.reading-progress-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.1);
    z-index: 9999;
}

.reading-progress-bar {
    height: 100%;
    background-color: #f7a801;
    width: 0;
    transition: width 0.1s ease-out;
}
</style>
